import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACTS_PAGE_SIZE } from "@/utils/contacts";

interface ContactsPagerProps {
  page: number;
  total: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export function ContactsPager({ page, total, onPageChange, disabled }: ContactsPagerProps) {
  if (total === 0) return null;
  const from = page * CONTACTS_PAGE_SIZE + 1;
  const to = Math.min(total, (page + 1) * CONTACTS_PAGE_SIZE);
  const lastPage = Math.max(0, Math.ceil(total / CONTACTS_PAGE_SIZE) - 1);

  return (
    <nav className="flex flex-wrap items-center justify-between gap-3" aria-label="Contacts pages">
      <p className="text-sm tabular-nums text-muted-foreground">
        {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          className="h-11"
          onClick={() => onPageChange(page - 1)}
          disabled={disabled || page === 0}
        >
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">Previous</span>
          <span className="sr-only sm:hidden">Previous page</span>
        </Button>
        <Button
          variant="outline"
          className="h-11"
          onClick={() => onPageChange(page + 1)}
          disabled={disabled || page >= lastPage}
        >
          Next
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
}
